var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-search_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-search_svg__st0{fill:#58585a}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-search_svg__st0",
    d: "M11 19.5c-4.7 0-8.5-3.8-8.5-8.5S6.3 2.5 11 2.5s8.5 3.8 8.5 8.5-3.8 8.5-8.5 8.5zm0-16c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5-3.4-7.5-7.5-7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-search_svg__st0",
    d: "M21 21.5c-.1 0-.3 0-.4-.1L16.3 17c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.4 4.4c.2.2.2.5 0 .7-.1.1-.3.1-.4.1z"
  })));
}
export default SvgIconSearch;